import {
  SUBSCRIPTIONS_LIST_SUCCESS,
  SUBSCRIPTIONS_INFO_SUCCESS,
  SUBSCRIPTIONS_UPDATE_SUCCESS,
  SUBSCRIPTIONS_STATUS_SUCCESS,
  CLEAR_SUBSCRIPTIONS_INFO,
} from "../actionTypes/subscriptions";
import {
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  INIT_URL,
  ON_SHOW_MESSAGE,
} from "../actionTypes/common";
import { userSignOut } from "./auth";
import axiosHttp from "../services/axiosCommon";

export const getSubscriptionsList = (queryInfo = {}) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const params = {
      page: queryInfo.page || 1,
      size: queryInfo.size || 10,
      ...(queryInfo.status && { status: queryInfo.status }),
      ...(queryInfo.merchant && { merchant: queryInfo.merchant }),
      ...(queryInfo.search && { search: queryInfo.search }),
    };
    const result = await axiosHttp.get("/v1/admin/subscriptions", { params });
    const { data } = result;
    if (!data.status && data.code !== 200) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({
      type: INIT_URL,
      payload: "/platforms",
    });
    dispatch({
      type: SUBSCRIPTIONS_LIST_SUCCESS,
      payload: {
        data: data.results?.data || [],
        count: data.results?.count || 0,
        pages: data.results?.pages || 0,
        queryInfo: data.results?.queryInfo || { page: 1, size: 10 },
      },
    });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const getSubscriptionInfo = (subscriptionId) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.get(`/v1/admin/subscriptions/${subscriptionId}`);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_HIDE_LOADER });
    dispatch({
      type: SUBSCRIPTIONS_INFO_SUCCESS,
      payload: data.results,
    });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const setSubscriptionInfo = (info) => async (dispatch) => {
  dispatch({
    type: SUBSCRIPTIONS_INFO_SUCCESS,
    payload: info,
  });
};

export const createSubscription = (payload) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.post("/v1/admin/subscriptions", payload);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const updateSubscription = (subscriptionId, payload) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.put(`/v1/admin/subscriptions/${subscriptionId}`, payload);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: SUBSCRIPTIONS_UPDATE_SUCCESS, payload: data.results });
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const patchSubscriptionStatus = (subscriptionId, status) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.patch(`/v1/admin/subscriptions/${subscriptionId}/status`, {
      status,
    });
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: SUBSCRIPTIONS_STATUS_SUCCESS, payload: data.results });
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const deleteSubscription = (infoData) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const { id } = infoData;
    const result = await axiosHttp.delete(`/v1/admin/subscriptions/${id}`);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    }
    dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Something went wrong",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const clearSubscriptionInfo = () => async (dispatch) => {
  dispatch({ type: CLEAR_SUBSCRIPTIONS_INFO });
};
